import type { PartialContext } from '@ms-cloudpack/api-server';
import open from 'open';

let lastOpenedUrl: string | undefined;
let altOpenBrowser: typeof openBrowser | null | undefined;

/** Open the browser. */
export async function openBrowser(
  options: {
    url: string;
  },
  // session properties aren't used directly in the function, but are used in a test via overrideOpenBrowser
  context: PartialContext<'telemetryClient', 'config' | 'urls'>,
): Promise<void> {
  const { url } = options;
  const { telemetryClient } = context;

  lastOpenedUrl = url;
  if (altOpenBrowser) {
    await altOpenBrowser(options, context);
  } else if (altOpenBrowser !== null) {
    // This span measures the time required to create a process for the browser, but it does not imply that the browser is fully open.
    await telemetryClient.tracer.startActiveSpan('OPEN_BROWSER', () => open(url, { newInstance: false }));
  }
}

/** Set an override for the browser opening behavior. `null` disables opening. */
export function overrideOpenBrowser(fn: typeof openBrowser | null): void {
  altOpenBrowser = fn;
}

/** Get the most recently opened URL (for tests) */
export function getLastOpenedUrl(): string | undefined {
  return lastOpenedUrl;
}

/** Reset the most recently opened URL (for tests) */
export function resetLastOpenedUrl(): void {
  lastOpenedUrl = undefined;
}
